import "./slider.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useCallback, useEffect, useState } from "react";
import { useRootContext } from "../../hooks/useRootContext";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Slider({ data, dataLength, setSliderIndex }) {
  const {
    id,
    brandIdentity,
    brandIdentityTextColor,
    title,
    desc,
    img,
    flagImg,
    projectUrl,
    workUrl
  } = data;

  const [changeSlider, setChangeSlider] = useState(false);
  const [fadeState, setFadeState] = useState("fade-in");

  const { setIsRouteLoading } = useRootContext();

  const navigate = useNavigate();

  const autoIncrease = useCallback(() => {
    setSliderIndex((prevIndex) => (prevIndex + 1) % dataLength);
  }, [dataLength, setSliderIndex]);

  const increaseIndex = () => {
    setFadeState("fade-out");
    setChangeSlider(false);
    setTimeout(() => {
      setSliderIndex((prevIndex) => (prevIndex + 1) % dataLength);
      setFadeState("fade-in");
    }, 500);
  };

  const decreaseIndex = () => {
    setFadeState("fade-out");
    setChangeSlider(false);
    setTimeout(() => {
      setSliderIndex((prevIndex) => (prevIndex - 1 + dataLength) % dataLength);
      setFadeState("fade-in");
    }, 500);
  };

  useEffect(() => {
    if (changeSlider === false) {
      setChangeSlider(true);
    }
  }, [changeSlider]);

  useEffect(() => {
    let interval;
    if (changeSlider) {
      interval = setInterval(() => {
        setFadeState("fade-out");
        setTimeout(() => {
          autoIncrease();
          setFadeState("fade-in");
        }, 800);
      }, 4000);
    }

    return () => clearInterval(interval);
  }, [autoIncrease, changeSlider]);

  return (
    <>
      {window.innerWidth > 768 ? (
        <div className="slider" data-id={id}>
          <div className="slider-first-column">
            <h2
              className={`slider-content brand-identity ${fadeState} ${brandIdentity === "TAXI APP" ? "gradient" : ""}`}
              style={brandIdentity === "TAXI APP"
                ? {
                  color: "auto"
                }
                : { color: brandIdentityTextColor }
              }
            >
              <span>{brandIdentity}</span>
              <img src={flagImg} alt="Flag Image" />
            </h2>
            <h1
              className={`slider-content ${fadeState}`}
              dangerouslySetInnerHTML={{ __html: title }}
            ></h1>
            <button
              className="visit-website-btn"
              style={{ backgroundColor: id === 5 ? "transparent" : brandIdentityTextColor, color: id === 3 ? "#050320" : "#FFF" }}
              onClick={() => window.open(projectUrl, "_blank")}
            >
              <>
                {(() => {
                  switch (id) {
                    case 2:
                    case 7:
                    case 8:
                    case 6:
                    case 9:
                      return (
                        <>
                          Discover
                          &nbsp;
                          <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
                            <g clipPath="url(#clip0_272_603)">
                              <path
                                d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_272_603">
                                <rect width={12} height={12} fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </>
                      );

                    case 5:
                      return (
                        <img src="/assets/images/slider-images/app-store.svg" />
                      );

                    default:
                      return id === 3 ? (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} viewBox="0 0 10 10" fill="none">
                            <path d="M5 0C4.01109 0 3.0444 0.293245 2.22215 0.842652C1.3999 1.39206 0.759043 2.17295 0.380605 3.08658C0.00216642 4.00021 -0.0968502 5.00555 0.0960758 5.97545C0.289002 6.94536 0.765206 7.83627 1.46447 8.53553C2.16373 9.23479 3.05465 9.711 4.02455 9.90392C4.99445 10.0969 5.99979 9.99783 6.91342 9.6194C7.82705 9.24096 8.60794 8.60009 9.15735 7.77785C9.70676 6.9556 10 5.98891 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0ZM7.57308 6.50384C7.65313 6.00658 7.693 5.50367 7.69231 5C7.69288 4.49618 7.65171 3.99318 7.56923 3.49615C8.60385 3.87692 9.23077 4.45385 9.23077 5C9.23077 5.54615 8.58077 6.15384 7.57308 6.50384ZM0.769233 5C0.769233 4.43461 1.41923 3.86538 2.42692 3.49615C2.34687 3.99342 2.307 4.49633 2.30769 5C2.30712 5.50382 2.34829 6.00682 2.43077 6.50384C1.39616 6.12308 0.769233 5.54615 0.769233 5ZM3.26923 1.15385C2.98267 1.6091 2.76493 2.10418 2.62308 2.62308C2.10438 2.76367 1.6093 2.98011 1.15385 3.26538C1.57859 2.32761 2.33069 1.57688 3.26923 1.15385ZM1.15385 6.73077C1.66696 7.0492 2.22798 7.28296 2.81539 7.42308H2.85C3.55321 7.59908 4.27511 7.68948 5 7.69231C5.23077 7.69231 5.45769 7.69231 5.67692 7.66923C5.77893 7.66209 5.87392 7.61472 5.941 7.53754C6.00808 7.46036 6.04176 7.3597 6.03462 7.25769C6.02748 7.15568 5.98011 7.06069 5.90293 6.99361C5.82575 6.92653 5.72508 6.89286 5.62308 6.9C5.42051 6.91538 5.21282 6.92308 5 6.92308C4.41567 6.92612 3.83274 6.86551 3.26154 6.74231C3.13798 6.16979 3.07609 5.58569 3.07692 5C3.07692 2.50769 4.09231 0.769231 5 0.769231C5.38462 0.769231 5.76923 1.06154 6.11154 1.59231C6.14583 1.64719 6.19342 1.69252 6.2499 1.72412C6.30637 1.75572 6.3699 1.77256 6.43462 1.77308C6.50793 1.77404 6.57999 1.75402 6.64231 1.71538C6.68499 1.68837 6.72194 1.65321 6.75103 1.61191C6.78012 1.57061 6.8008 1.52399 6.81187 1.4747C6.82294 1.42541 6.8242 1.37442 6.81556 1.32465C6.80692 1.27488 6.78857 1.22729 6.76154 1.18462C6.75349 1.17117 6.74449 1.15832 6.73462 1.14615C7.67374 1.57278 8.42465 2.3278 8.84615 3.26923C8.31411 2.94119 7.7321 2.70215 7.12308 2.56154C6.42811 2.39217 5.71531 2.30694 5 2.30769C4.76923 2.30769 4.54231 2.30769 4.32308 2.33077C4.27257 2.3343 4.22325 2.34775 4.17794 2.37035C4.13263 2.39294 4.09221 2.42424 4.059 2.46246C4.02578 2.50067 4.00042 2.54506 3.98436 2.59307C3.9683 2.64109 3.96185 2.6918 3.96539 2.74231C3.96892 2.79282 3.98237 2.84213 4.00497 2.88744C4.02756 2.93275 4.05886 2.97317 4.09707 3.00639C4.13529 3.0396 4.17967 3.06496 4.22769 3.08103C4.27571 3.09709 4.32642 3.10354 4.37692 3.1C4.58205 3.08461 4.78974 3.07692 5 3.07692C5.58433 3.07387 6.16726 3.13449 6.73846 3.25769C6.86202 3.83021 6.92391 4.4143 6.92308 5C6.92308 7.49231 5.90769 9.23077 5 9.23077C4.61539 9.23077 4.23077 8.93846 3.88846 8.40769C3.86366 8.36106 3.82951 8.32004 3.78816 8.28718C3.74681 8.25433 3.69913 8.23034 3.6481 8.21672C3.59707 8.2031 3.54378 8.20013 3.49155 8.20801C3.43933 8.21589 3.38928 8.23443 3.34454 8.2625C3.29979 8.29056 3.26131 8.32754 3.23148 8.37113C3.20166 8.41472 3.18113 8.46398 3.17118 8.51585C3.16123 8.56773 3.16206 8.62109 3.17364 8.67262C3.18522 8.72416 3.20728 8.77275 3.23846 8.81538C3.24652 8.82882 3.25551 8.84168 3.26539 8.85384C2.32626 8.42722 1.57535 7.6722 1.15385 6.73077ZM6.73077 8.84615C7.01837 8.38733 7.23614 7.88828 7.37692 7.36538C7.89498 7.22839 8.39003 7.01586 8.84615 6.73461C8.42141 7.67239 7.66931 8.42312 6.73077 8.84615Z" fill="#050320" />
                          </svg>
                          &nbsp;
                          Visit Website
                        </>
                      ) : (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} viewBox="0 0 10 10" fill="none">
                            <path d="M5 0C4.01109 0 3.0444 0.293245 2.22215 0.842652C1.3999 1.39206 0.759043 2.17295 0.380605 3.08658C0.00216642 4.00021 -0.0968502 5.00555 0.0960758 5.97545C0.289002 6.94536 0.765206 7.83627 1.46447 8.53553C2.16373 9.23479 3.05465 9.711 4.02455 9.90392C4.99445 10.0969 5.99979 9.99783 6.91342 9.6194C7.82705 9.24096 8.60794 8.60009 9.15735 7.77785C9.70676 6.9556 10 5.98891 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0ZM7.57308 6.50384C7.65313 6.00658 7.693 5.50367 7.69231 5C7.69288 4.49618 7.65171 3.99318 7.56923 3.49615C8.60385 3.87692 9.23077 4.45385 9.23077 5C9.23077 5.54615 8.58077 6.15384 7.57308 6.50384ZM0.769233 5C0.769233 4.43461 1.41923 3.86538 2.42692 3.49615C2.34687 3.99342 2.307 4.49633 2.30769 5C2.30712 5.50382 2.34829 6.00682 2.43077 6.50384C1.39616 6.12308 0.769233 5.54615 0.769233 5ZM3.26923 1.15385C2.98267 1.6091 2.76493 2.10418 2.62308 2.62308C2.10438 2.76367 1.6093 2.98011 1.15385 3.26538C1.57859 2.32761 2.33069 1.57688 3.26923 1.15385ZM1.15385 6.73077C1.66696 7.0492 2.22798 7.28296 2.81539 7.42308H2.85C3.55321 7.59908 4.27511 7.68948 5 7.69231C5.23077 7.69231 5.45769 7.69231 5.67692 7.66923C5.77893 7.66209 5.87392 7.61472 5.941 7.53754C6.00808 7.46036 6.04176 7.3597 6.03462 7.25769C6.02748 7.15568 5.98011 7.06069 5.90293 6.99361C5.82575 6.92653 5.72508 6.89286 5.62308 6.9C5.42051 6.91538 5.21282 6.92308 5 6.92308C4.41567 6.92612 3.83274 6.86551 3.26154 6.74231C3.13798 6.16979 3.07609 5.58569 3.07692 5C3.07692 2.50769 4.09231 0.769231 5 0.769231C5.38462 0.769231 5.76923 1.06154 6.11154 1.59231C6.14583 1.64719 6.19342 1.69252 6.2499 1.72412C6.30637 1.75572 6.3699 1.77256 6.43462 1.77308C6.50793 1.77404 6.57999 1.75402 6.64231 1.71538C6.68499 1.68837 6.72194 1.65321 6.75103 1.61191C6.78012 1.57061 6.8008 1.52399 6.81187 1.4747C6.82294 1.42541 6.8242 1.37442 6.81556 1.32465C6.80692 1.27488 6.78857 1.22729 6.76154 1.18462C6.75349 1.17117 6.74449 1.15832 6.73462 1.14615C7.67374 1.57278 8.42465 2.3278 8.84615 3.26923C8.31411 2.94119 7.7321 2.70215 7.12308 2.56154C6.42811 2.39217 5.71531 2.30694 5 2.30769C4.76923 2.30769 4.54231 2.30769 4.32308 2.33077C4.27257 2.3343 4.22325 2.34775 4.17794 2.37035C4.13263 2.39294 4.09221 2.42424 4.059 2.46246C4.02578 2.50067 4.00042 2.54506 3.98436 2.59307C3.9683 2.64109 3.96185 2.6918 3.96539 2.74231C3.96892 2.79282 3.98237 2.84213 4.00497 2.88744C4.02756 2.93275 4.05886 2.97317 4.09707 3.00639C4.13529 3.0396 4.17967 3.06496 4.22769 3.08103C4.27571 3.09709 4.32642 3.10354 4.37692 3.1C4.58205 3.08461 4.78974 3.07692 5 3.07692C5.58433 3.07387 6.16726 3.13449 6.73846 3.25769C6.86202 3.83021 6.92391 4.4143 6.92308 5C6.92308 7.49231 5.90769 9.23077 5 9.23077C4.61539 9.23077 4.23077 8.93846 3.88846 8.40769C3.86366 8.36106 3.82951 8.32004 3.78816 8.28718C3.74681 8.25433 3.69913 8.23034 3.6481 8.21672C3.59707 8.2031 3.54378 8.20013 3.49155 8.20801C3.43933 8.21589 3.38928 8.23443 3.34454 8.2625C3.29979 8.29056 3.26131 8.32754 3.23148 8.37113C3.20166 8.41472 3.18113 8.46398 3.17118 8.51585C3.16123 8.56773 3.16206 8.62109 3.17364 8.67262C3.18522 8.72416 3.20728 8.77275 3.23846 8.81538C3.24652 8.82882 3.25551 8.84168 3.26539 8.85384C2.32626 8.42722 1.57535 7.6722 1.15385 6.73077ZM6.73077 8.84615C7.01837 8.38733 7.23614 7.88828 7.37692 7.36538C7.89498 7.22839 8.39003 7.01586 8.84615 6.73461C8.42141 7.67239 7.66931 8.42312 6.73077 8.84615Z" fill="white" />
                          </svg>
                          &nbsp;
                          Visit Website
                        </>
                      );
                  }
                })()}
              </>
            </button>
            <p className={`slider-content ${fadeState}`}>{desc}</p>
            <button
              onClick={() => {
                navigate("/contact-us");
                setIsRouteLoading(true);
              }}
              className="slider-btn"
            >
              Have a Project?
            </button>
            <div className="sliding-buttons">
              <button className="prev" onClick={decreaseIndex}>
                <span>Prev</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={41}
                  height={8}
                  viewBox="0 0 41 8"
                  fill="none"
                >
                  <path
                    d="M0.646446 3.64644C0.451183 3.84171 0.451183 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.73079 4.34027 7.73079 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82842L1.70711 4L4.53553 1.17157C4.7308 0.976308 4.7308 0.659725 4.53553 0.464463C4.34027 0.269201 4.02369 0.269201 3.82843 0.464463L0.646446 3.64644ZM41 3.5L1 3.5L1 4.5L41 4.5L41 3.5Z"
                    fill="#050320"
                  />
                </svg>
              </button>
              <button className="next" onClick={increaseIndex}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={41}
                  height={8}
                  viewBox="0 0 41 8"
                  fill="none"
                >
                  <path
                    d="M40.3536 4.35355C40.5488 4.15829 40.5488 3.84171 40.3536 3.64645L37.1716 0.464466C36.9763 0.269204 36.6597 0.269204 36.4645 0.464466C36.2692 0.659728 36.2692 0.976311 36.4645 1.17157L39.2929 4L36.4645 6.82843C36.2692 7.02369 36.2692 7.34027 36.4645 7.53553C36.6597 7.7308 36.9763 7.7308 37.1716 7.53553L40.3536 4.35355ZM0 4.5H40V3.5H0V4.5Z"
                    fill="#050320"
                  />
                </svg>
                <span>Next</span>
              </button>
            </div>
          </div>

          <div className="slider-second-column">
            <LazyLoadImage
              onClick={() => {
                navigate(workUrl);
                setIsRouteLoading(true);
              }}
              key={img}
              effect="blur"
              className={`slider-content ${fadeState}`}
              src={img}
              loading="eager"
              fetchPriority="high"
              alt={`${brandIdentity} Project Img`}
            />
          </div>

          <div className="slider-third-column">
            <h1 className={`slider-content ${fadeState}`}>0{id}</h1>
            <div className="slider-line-container">
              <div
                className={`slider-line ${changeSlider ? "slider-fill-line" : ""
                  }`}
              ></div>
            </div>
          </div>
        </div>
      ) : (
        <div className="slider" data-id={id}>
          <div className="slider-first-column-m">
            <div className="slider-line-container">
              <div
                className={`slider-line ${changeSlider ? "slider-fill-line-h" : ""
                  }`}
              ></div>
            </div>
            <h1 className={`slider-content ${fadeState}`}>0{id}</h1>
          </div>

          <div className="slider-third-column-m">
            <LazyLoadImage
              onClick={() => {
                navigate(workUrl);
                setIsRouteLoading(true);
              }}
              key={img}
              effect="blur"
              className={`slider-content ${fadeState}`}
              src={img}
              loading="eager"
              fetchPriority="high"
              alt={`${brandIdentity} Project Img`}
            />
            <div className="slider-second-column-m">
              <h2
                className={`slider-content ${fadeState}`}
                style={{ color: brandIdentityTextColor }}
              >
                {brandIdentity}
              </h2>
              <div className="sliding-buttons">
                <button className="next" onClick={increaseIndex}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={41}
                    height={8}
                    viewBox="0 0 41 8"
                    fill="none"
                  >
                    <path
                      d="M40.3536 4.35355C40.5488 4.15829 40.5488 3.84171 40.3536 3.64645L37.1716 0.464466C36.9763 0.269204 36.6597 0.269204 36.4645 0.464466C36.2692 0.659728 36.2692 0.976311 36.4645 1.17157L39.2929 4L36.4645 6.82843C36.2692 7.02369 36.2692 7.34027 36.4645 7.53553C36.6597 7.7308 36.9763 7.7308 37.1716 7.53553L40.3536 4.35355ZM0 4.5H40V3.5H0V4.5Z"
                      fill="#050320"
                    />
                  </svg>
                  <span>Next</span>
                </button>
              </div>
            </div>

            <h1
              className={`slider-content ${fadeState}`}
              dangerouslySetInnerHTML={{ __html: title }}
            ></h1>
            <img className="flag-img" src={flagImg} alt="Flag Image" />
            <button
              className="visit-website-btn"
              style={{ backgroundColor: id === 5 ? "transparent" : brandIdentityTextColor, color: id === 3 ? "#050320" : "#FFF" }}
              onClick={() => window.open(projectUrl, "_blank")}
            >
              <>
                {(() => {
                  switch (id) {
                    case 2:
                    case 7:
                    case 8:
                    case 9:
                      return (
                        <>
                          Discover
                          &nbsp;
                          <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
                            <g clipPath="url(#clip0_272_603)">
                              <path
                                d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_272_603">
                                <rect width={12} height={12} fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </>
                      );

                    case 5:
                      return (
                        <img src="/assets/images/slider-images/app-store.svg" />
                      );

                    default:
                      return id === 3 ? (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} viewBox="0 0 10 10" fill="none">
                            <path d="M5 0C4.01109 0 3.0444 0.293245 2.22215 0.842652C1.3999 1.39206 0.759043 2.17295 0.380605 3.08658C0.00216642 4.00021 -0.0968502 5.00555 0.0960758 5.97545C0.289002 6.94536 0.765206 7.83627 1.46447 8.53553C2.16373 9.23479 3.05465 9.711 4.02455 9.90392C4.99445 10.0969 5.99979 9.99783 6.91342 9.6194C7.82705 9.24096 8.60794 8.60009 9.15735 7.77785C9.70676 6.9556 10 5.98891 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0ZM7.57308 6.50384C7.65313 6.00658 7.693 5.50367 7.69231 5C7.69288 4.49618 7.65171 3.99318 7.56923 3.49615C8.60385 3.87692 9.23077 4.45385 9.23077 5C9.23077 5.54615 8.58077 6.15384 7.57308 6.50384ZM0.769233 5C0.769233 4.43461 1.41923 3.86538 2.42692 3.49615C2.34687 3.99342 2.307 4.49633 2.30769 5C2.30712 5.50382 2.34829 6.00682 2.43077 6.50384C1.39616 6.12308 0.769233 5.54615 0.769233 5ZM3.26923 1.15385C2.98267 1.6091 2.76493 2.10418 2.62308 2.62308C2.10438 2.76367 1.6093 2.98011 1.15385 3.26538C1.57859 2.32761 2.33069 1.57688 3.26923 1.15385ZM1.15385 6.73077C1.66696 7.0492 2.22798 7.28296 2.81539 7.42308H2.85C3.55321 7.59908 4.27511 7.68948 5 7.69231C5.23077 7.69231 5.45769 7.69231 5.67692 7.66923C5.77893 7.66209 5.87392 7.61472 5.941 7.53754C6.00808 7.46036 6.04176 7.3597 6.03462 7.25769C6.02748 7.15568 5.98011 7.06069 5.90293 6.99361C5.82575 6.92653 5.72508 6.89286 5.62308 6.9C5.42051 6.91538 5.21282 6.92308 5 6.92308C4.41567 6.92612 3.83274 6.86551 3.26154 6.74231C3.13798 6.16979 3.07609 5.58569 3.07692 5C3.07692 2.50769 4.09231 0.769231 5 0.769231C5.38462 0.769231 5.76923 1.06154 6.11154 1.59231C6.14583 1.64719 6.19342 1.69252 6.2499 1.72412C6.30637 1.75572 6.3699 1.77256 6.43462 1.77308C6.50793 1.77404 6.57999 1.75402 6.64231 1.71538C6.68499 1.68837 6.72194 1.65321 6.75103 1.61191C6.78012 1.57061 6.8008 1.52399 6.81187 1.4747C6.82294 1.42541 6.8242 1.37442 6.81556 1.32465C6.80692 1.27488 6.78857 1.22729 6.76154 1.18462C6.75349 1.17117 6.74449 1.15832 6.73462 1.14615C7.67374 1.57278 8.42465 2.3278 8.84615 3.26923C8.31411 2.94119 7.7321 2.70215 7.12308 2.56154C6.42811 2.39217 5.71531 2.30694 5 2.30769C4.76923 2.30769 4.54231 2.30769 4.32308 2.33077C4.27257 2.3343 4.22325 2.34775 4.17794 2.37035C4.13263 2.39294 4.09221 2.42424 4.059 2.46246C4.02578 2.50067 4.00042 2.54506 3.98436 2.59307C3.9683 2.64109 3.96185 2.6918 3.96539 2.74231C3.96892 2.79282 3.98237 2.84213 4.00497 2.88744C4.02756 2.93275 4.05886 2.97317 4.09707 3.00639C4.13529 3.0396 4.17967 3.06496 4.22769 3.08103C4.27571 3.09709 4.32642 3.10354 4.37692 3.1C4.58205 3.08461 4.78974 3.07692 5 3.07692C5.58433 3.07387 6.16726 3.13449 6.73846 3.25769C6.86202 3.83021 6.92391 4.4143 6.92308 5C6.92308 7.49231 5.90769 9.23077 5 9.23077C4.61539 9.23077 4.23077 8.93846 3.88846 8.40769C3.86366 8.36106 3.82951 8.32004 3.78816 8.28718C3.74681 8.25433 3.69913 8.23034 3.6481 8.21672C3.59707 8.2031 3.54378 8.20013 3.49155 8.20801C3.43933 8.21589 3.38928 8.23443 3.34454 8.2625C3.29979 8.29056 3.26131 8.32754 3.23148 8.37113C3.20166 8.41472 3.18113 8.46398 3.17118 8.51585C3.16123 8.56773 3.16206 8.62109 3.17364 8.67262C3.18522 8.72416 3.20728 8.77275 3.23846 8.81538C3.24652 8.82882 3.25551 8.84168 3.26539 8.85384C2.32626 8.42722 1.57535 7.6722 1.15385 6.73077ZM6.73077 8.84615C7.01837 8.38733 7.23614 7.88828 7.37692 7.36538C7.89498 7.22839 8.39003 7.01586 8.84615 6.73461C8.42141 7.67239 7.66931 8.42312 6.73077 8.84615Z" fill="#050320" />
                          </svg>
                          &nbsp;
                          Visit Website
                        </>
                      ) : (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} viewBox="0 0 10 10" fill="none">
                            <path d="M5 0C4.01109 0 3.0444 0.293245 2.22215 0.842652C1.3999 1.39206 0.759043 2.17295 0.380605 3.08658C0.00216642 4.00021 -0.0968502 5.00555 0.0960758 5.97545C0.289002 6.94536 0.765206 7.83627 1.46447 8.53553C2.16373 9.23479 3.05465 9.711 4.02455 9.90392C4.99445 10.0969 5.99979 9.99783 6.91342 9.6194C7.82705 9.24096 8.60794 8.60009 9.15735 7.77785C9.70676 6.9556 10 5.98891 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0ZM7.57308 6.50384C7.65313 6.00658 7.693 5.50367 7.69231 5C7.69288 4.49618 7.65171 3.99318 7.56923 3.49615C8.60385 3.87692 9.23077 4.45385 9.23077 5C9.23077 5.54615 8.58077 6.15384 7.57308 6.50384ZM0.769233 5C0.769233 4.43461 1.41923 3.86538 2.42692 3.49615C2.34687 3.99342 2.307 4.49633 2.30769 5C2.30712 5.50382 2.34829 6.00682 2.43077 6.50384C1.39616 6.12308 0.769233 5.54615 0.769233 5ZM3.26923 1.15385C2.98267 1.6091 2.76493 2.10418 2.62308 2.62308C2.10438 2.76367 1.6093 2.98011 1.15385 3.26538C1.57859 2.32761 2.33069 1.57688 3.26923 1.15385ZM1.15385 6.73077C1.66696 7.0492 2.22798 7.28296 2.81539 7.42308H2.85C3.55321 7.59908 4.27511 7.68948 5 7.69231C5.23077 7.69231 5.45769 7.69231 5.67692 7.66923C5.77893 7.66209 5.87392 7.61472 5.941 7.53754C6.00808 7.46036 6.04176 7.3597 6.03462 7.25769C6.02748 7.15568 5.98011 7.06069 5.90293 6.99361C5.82575 6.92653 5.72508 6.89286 5.62308 6.9C5.42051 6.91538 5.21282 6.92308 5 6.92308C4.41567 6.92612 3.83274 6.86551 3.26154 6.74231C3.13798 6.16979 3.07609 5.58569 3.07692 5C3.07692 2.50769 4.09231 0.769231 5 0.769231C5.38462 0.769231 5.76923 1.06154 6.11154 1.59231C6.14583 1.64719 6.19342 1.69252 6.2499 1.72412C6.30637 1.75572 6.3699 1.77256 6.43462 1.77308C6.50793 1.77404 6.57999 1.75402 6.64231 1.71538C6.68499 1.68837 6.72194 1.65321 6.75103 1.61191C6.78012 1.57061 6.8008 1.52399 6.81187 1.4747C6.82294 1.42541 6.8242 1.37442 6.81556 1.32465C6.80692 1.27488 6.78857 1.22729 6.76154 1.18462C6.75349 1.17117 6.74449 1.15832 6.73462 1.14615C7.67374 1.57278 8.42465 2.3278 8.84615 3.26923C8.31411 2.94119 7.7321 2.70215 7.12308 2.56154C6.42811 2.39217 5.71531 2.30694 5 2.30769C4.76923 2.30769 4.54231 2.30769 4.32308 2.33077C4.27257 2.3343 4.22325 2.34775 4.17794 2.37035C4.13263 2.39294 4.09221 2.42424 4.059 2.46246C4.02578 2.50067 4.00042 2.54506 3.98436 2.59307C3.9683 2.64109 3.96185 2.6918 3.96539 2.74231C3.96892 2.79282 3.98237 2.84213 4.00497 2.88744C4.02756 2.93275 4.05886 2.97317 4.09707 3.00639C4.13529 3.0396 4.17967 3.06496 4.22769 3.08103C4.27571 3.09709 4.32642 3.10354 4.37692 3.1C4.58205 3.08461 4.78974 3.07692 5 3.07692C5.58433 3.07387 6.16726 3.13449 6.73846 3.25769C6.86202 3.83021 6.92391 4.4143 6.92308 5C6.92308 7.49231 5.90769 9.23077 5 9.23077C4.61539 9.23077 4.23077 8.93846 3.88846 8.40769C3.86366 8.36106 3.82951 8.32004 3.78816 8.28718C3.74681 8.25433 3.69913 8.23034 3.6481 8.21672C3.59707 8.2031 3.54378 8.20013 3.49155 8.20801C3.43933 8.21589 3.38928 8.23443 3.34454 8.2625C3.29979 8.29056 3.26131 8.32754 3.23148 8.37113C3.20166 8.41472 3.18113 8.46398 3.17118 8.51585C3.16123 8.56773 3.16206 8.62109 3.17364 8.67262C3.18522 8.72416 3.20728 8.77275 3.23846 8.81538C3.24652 8.82882 3.25551 8.84168 3.26539 8.85384C2.32626 8.42722 1.57535 7.6722 1.15385 6.73077ZM6.73077 8.84615C7.01837 8.38733 7.23614 7.88828 7.37692 7.36538C7.89498 7.22839 8.39003 7.01586 8.84615 6.73461C8.42141 7.67239 7.66931 8.42312 6.73077 8.84615Z" fill="white" />
                          </svg>
                          &nbsp;
                          Visit Website
                        </>
                      );
                  }
                })()}
              </>
            </button>
            <p className={`slider-content ${fadeState}`}>{desc}</p>
            <button
              onClick={() => {
                navigate("/contact-us");
                setIsRouteLoading(true);
              }}
              className="slider-btn"
            >
              Have a Project?
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Slider;
